import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';

const CompactChipField = styled(Flex)`
  flex: 1;
  min-width: 0;

  & [aria-label='chiplist'] {
    padding: 0;
    min-height: 40px;
  }
`;

export default CompactChipField;
